<template>
  <CRow>
    <CCol col>
      <CCard>
        <CCardHeader>
          <CRow class="justify-content-between px-3">
            <h5>{{ title }}</h5>
            <div class="d-flex">
              <CSelect
                style="width: 220px"
                class="mx-2 my-0"
                horizontal
                label="Type"
                :value.sync="search.type"
                :options="search.options"
                @change="searchChangeType"
              />
              <CInput
                style="width: 360px"
                class="my-0 px-0"
                :placeholder="`Search ${search.placeholder}`"
                :value.sync="search.value"
              >
                <template #append>
                  <CButton color="primary" @click="doApplyFilter"
                    >Search</CButton
                  >
                  <CButton
                    class="ml-2"
                    size="sm"
                    color="info"
                    variant="outline"
                    @click="isShowFilter = !isShowFilter"
                  >
                    <CIcon
                      :name="isShowFilter ? 'cil-x' : 'cil-arrow-bottom'"
                    />
                    Filter</CButton
                  >
                </template>
              </CInput>
            </div>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CCollapse :show="isShowFilter">
            <CCard body-wrapper>
              <CRow>
                <h5 class="ml-3 flex-grow-1">Filter</h5>
                <CButton
                  class="ml-auto m-2"
                  variant="outline"
                  color="info"
                  @click="doResetFilter"
                  >Reset</CButton
                >
                <CButton class="m-2" color="info" @click="onApplyFilter"
                  >Apply</CButton
                >
              </CRow>
              <CRow>
                <CCol md="4">
                  <SelectAllTreeselect
                    v-model="filter.promoCodeType"
                    :options="filterData.promoCodeType"
                    placeholder="Promo code type"
                  />
                </CCol>
                <CCol md="4">
                  <date-picker
                    v-model="filter.dateRangeSelected"
                    range
                    format="YYYY-MM-DD"
                    placeholder="Date range"
                  ></date-picker>
                </CCol>
              </CRow>
            </CCard>
          </CCollapse>
          <CDataTable
            hover
            striped
            border
            :loading="loading"
            :itemsPerPageSelect="false"
            :items="promotions"
            :fields="fields"
            :items-per-page="pagination.limit"
            :pagination="false"
          >
            <td slot="redeemer_id" slot-scope="{ item }">
              <span v-if="item.redeemer_id">
                <!-- <CLink :href="'#/consumers/' + item.redeemer_id">
                  {{ item.redeemer_id }}
                </CLink> -->
                <ConsumerHoverComponent :id="item.redeemer_id" />
              </span>
              <span v-else>-</span>
            </td>
            <td slot="referrer_id" slot-scope="{ item }">
              <span v-if="item.referrer_id">
                <ConsumerHoverComponent :id="item.referrer_id" />
              </span>
              <span v-else>-</span>
            </td>
            <td slot="phone_number" slot-scope="{ item }">
              {{ item.phone_number || '-' }}
            </td>
            <td slot="booking_id" slot-scope="{ item }">
              <CLink :href="'#/bookings/' + item.booking_id">
                {{ item.booking_id }}
              </CLink>
            </td>
            <td slot="job_id" slot-scope="{ item }">
              <span v-if="item.job_id">{{ item.job_id }}</span>
              <span v-else>-</span>
            </td>
            <td slot="created_at" slot-scope="{ item }">
              {{ item.created_at | moment(datetimeFormat) }}
            </td>
            <td slot="promo_code_type" slot-scope="{ item }">
              {{ formatPromoType(item.promo_code_type) }}
            </td>
            <td slot="promo_code" slot-scope="{ item }">
              {{ formatPromoCode(item) }}
            </td>
          </CDataTable>

          <MyPagination
            :limit="pagination.limit"
            :total="pagination.total"
            :activePage="pagination.page"
            @changePage="onChangePage"
            @changePageSize="onChangePageSize"
          />
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapGetters } from 'vuex';
import { ACTION_FETCH_PROMOTIONS } from '@/store/actions.type';
import { Common } from '@/constants';
import moment from 'moment';
import MyPagination from '@/components/MyPagination.vue';
import ConsumerHoverComponent from '@/components/ConsumerHoverComponent.vue';
import SelectAllTreeselect from '@/components/SelectAllTreeselect.vue';

export default {
  name: 'Restrictions',
  components: { MyPagination, ConsumerHoverComponent, SelectAllTreeselect },
  data() {
    return {
      title: 'Restrictions',
      datetimeFormat: Common.datetimeFormat,
      loading: false,
      isShowFilter: false,
      fields: [
        { key: 'redeemer_id', label: 'Consumer', _style: 'width: 140px' },
        { key: 'phone_number', label: 'Mobile number', _style: 'width: 180px' },
        { key: 'promo_code_type', label: 'Promo code type' },
        { key: 'booking_id', label: 'Booking ID' },
        { key: 'job_id', label: 'Job ID' },
        { key: 'promo_code', label: 'Promo code' },
        { key: 'referrer_id', label: 'Referrer', _style: 'width: 140px' },
        { key: 'created_at', label: 'Date and time' },
      ],
      search: {
        type: 'phone_number',
        value: '',
        placeholder: 'Mobile number',
        options: [
          { value: 'phone_number', label: 'Mobile number' },
          { value: 'redeemer_id', label: 'Consumer ID' },
          { value: 'promo_code', label: 'Promo code' },
        ],
      },
      filter: {
        promoCodeType: null,
        dateRangeSelected: null,
      },
      filterData: {
        promoCodeType: [
          { id: 'referral', label: 'Referral' },
          { id: 'first_booking', label: 'First booking' },
        ],
      },
      pagination: {
        page: 1,
        limit: 25,
        total: 0,
      },
    };
  },
  computed: {
    ...mapGetters({
      promotions: 'promotions',
      paging: 'pagingPromotions',
    }),
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.pagination.page = Number(route.query.page);
        }

        if (route.query && route.query.limit) {
          this.pagination.limit = Number(route.query.limit);
        }
      },
    },
  },
  mounted() {
    this.doApplyFilter();
  },
  methods: {
    searchChangeType() {
      const selected = this.search.options.find(
        (x) => x.value === this.search.type
      );
      this.search.placeholder = selected ? selected.label : '';
      this.search.value = '';
    },
    updateURL() {
      this.$router.push({
        query: {
          page: this.pagination.page,
          limit: this.pagination.limit,
        },
      });
    },
    onChangePage(page) {
      this.pagination.page = page;
      this.updateURL();
      this.doApplyFilter();
    },
    onChangePageSize(limit) {
      this.pagination.limit = limit;
      this.pagination.page = 1;
      this.updateURL();
      this.doApplyFilter();
    },
    onApplyFilter() {
      this.pagination.page = 1;
      this.pagination.limit = 25;
      this.doApplyFilter();
    },
    doResetFilter() {
      this.filter.promoCodeType = null;
      this.filter.dateRangeSelected = null;
      this.pagination.page = 1;
      this.pagination.limit = 25;
      this.pagination.total = 0;
      this.search.value = '';
      this.search.type = 'phone_number';
      this.searchChangeType();
      this.updateURL();
      this.doApplyFilter();
    },
    buildQuery() {
      let query = {
        page: this.pagination.page,
        limit: this.pagination.limit,
      };

      if (this.search.value && this.search.value.length > 0) {
        const searchKey =
          this.search.type === 'phone_number' ? 'phone' : this.search.type;
        query = {
          ...query,
          [searchKey]: this.search.value,
        };
      }

      if (this.filter.promoCodeType?.length > 0) {
        query = {
          ...query,
          promo_code_type: this.filter.promoCodeType,
        };
      }

      if (
        this.filter.dateRangeSelected &&
        this.filter.dateRangeSelected.length === 2 &&
        this.filter.dateRangeSelected[0] &&
        this.filter.dateRangeSelected[1]
      ) {
        query = {
          ...query,
          from: moment(this.filter.dateRangeSelected[0])
            .startOf('day')
            .format('YYYY-MM-DD'),
          to: moment(this.filter.dateRangeSelected[1])
            .endOf('day')
            .format('YYYY-MM-DD'),
        };
      }

      return query;
    },
    doApplyFilter() {
      const query = this.buildQuery();
      this.loading = true;
      this.$store
        .dispatch(ACTION_FETCH_PROMOTIONS, query)
        .then(() => {
          const paging = this.paging || {};
          this.pagination = {
            page: Number(paging.page || query.page || 1),
            limit: Number(paging.limit || query.limit || 25),
            total: Number(paging.total_rows || 0),
          };
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatPromoType(type) {
      if (!type) {
        return '-';
      }
      const mapping = {
        referral: 'Referral',
        first_booking: 'First booking',
      };
      return mapping[type] || type;
    },
    formatPromoCode(item) {
      if (!item) {
        return '-';
      }
      if (item.promo_code_type === 'first_booking') {
        return '-';
      }
      return item.promo_code || '';
    },
  },
};
</script>

<style scoped></style>
